module.exports = "<navbar></navbar>\n\n<h1>Thank you!</h1>\n<div class=\"contanier\">\n<h4>You are all Signed up!</h4>\n<p>We really appreciate you sigining up for our service. Enjoy all the new friends and delicious food!</p>\n<button (click)=\"goHome()\">Find Food!</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/thank-you/thank-you.component.html
// module id = ../../../../../src/app/thank-you/thank-you.component.html
// module chunks = main